// assets/faq-yt-player.js
(function () {
  'use strict';
  // DEBUG: toggle to false to silence logs
  var DEBUG = true;
  function log() { if (!DEBUG) return; try { console.log.apply(console, arguments); } catch(e){} }

  // Robust extractor for many YT URL formats
  function extractYouTubeID(url) {
    if (!url) return null;
    // standard regex for many youtube variants
    var re = /(?:youtube(?:-nocookie)?\.com\/(?:.*v(?:\/|=)|(?:embed|v|shorts)\/)|youtu\.be\/)([A-Za-z0-9_-]{6,11})/;
    var m = url.match(re);
    if (m && m[1]) return m[1];
    // fallback: try v= query param
    try {
      var afterV = (url.split('v=')[1] || '').split('&')[0];
      if (afterV && afterV.length >= 6 && afterV.length <= 11) return afterV;
    } catch(e){}
    // fallback: last path segment
    try {
      var parts = url.split('/');
      var maybe = parts[parts.length - 1].split('?')[0].split('&')[0];
      if (maybe && maybe.length >= 6 && maybe.length <= 11) return maybe;
    } catch(e){}
    return null;
  }

  function stopOtherPlayers(currentWrapper) {
    document.querySelectorAll('.faq-yt-wrapper').forEach(function (wrapper) {
      if (wrapper === currentWrapper) return;
      var iframe = wrapper.querySelector('.faq-yt-iframe');
      if (iframe) iframe.remove();
      var btn = wrapper.querySelector('.yt-player');
      if (btn) {
        btn.style.display = '';
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function createIframe(wrapper, vid, controlsId) {
    if (!vid) return null;
    var iframeWrap = document.createElement('div');
    iframeWrap.className = 'faq-yt-iframe';
    iframeWrap.id = controlsId || ('faq-yt-iframe-' + Math.random().toString(36).substr(2,6));

    var iframe = document.createElement('iframe');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('frameborder', '0');
    iframe.src = 'https://www.youtube.com/embed/' + vid + '?autoplay=1&rel=0';

    iframeWrap.appendChild(iframe);
    wrapper.appendChild(iframeWrap);
    return iframeWrap;
  }

  function ensureThumbnail(btn, vid) {
    if (!btn) return;
    // Force pointer events in case theme CSS suppressed it
    btn.style.pointerEvents = 'auto';
    var currentBg = btn.style.backgroundImage;
    if ((!currentBg || currentBg === 'none' || currentBg === '') && vid) {
      btn.style.backgroundImage = 'url("https://img.youtube.com/vi/' + vid + '/hqdefault.jpg")';
    }
  }

  // MAIN: event delegation for clicks on .yt-player
  document.addEventListener('click', function (ev) {
    var el = ev.target;
    var btn = el.closest ? el.closest('.yt-player') : null;
    if (!btn) return;
    // debug log click target
    log('[faq-yt] Click detected on .yt-player', btn);

    // Prevent native button focus/submit behavior
    ev.preventDefault();
    ev.stopPropagation();

    var wrapper = btn.closest('.faq-yt-wrapper');
    if (!wrapper) {
      log('[faq-yt] Warning: .faq-yt-wrapper parent not found');
      return;
    }

    // Try to get video id from data attribute, else parse URL
    var vid = btn.getAttribute('data-yt-id') || null;
    var url = btn.getAttribute('data-yt-url') || null;
    if (!vid && url) vid = extractYouTubeID(url);

    // Extra fallback: try any anchor inside wrapper
    if (!vid) {
      var anchor = wrapper.querySelector('a[href]');
      if (anchor) {
        vid = extractYouTubeID(anchor.href);
      }
    }

    log('[faq-yt] resolved vid:', vid, 'from url:', url);

    if (!vid) {
      // If no id found, open url in new tab as fallback
      if (url) {
        log('[faq-yt] No vid parsed — opening link in new tab');
        window.open(url, '_blank', 'noopener');
      } else {
        log('[faq-yt] No vid and no url — nothing to do');
      }
      return;
    }

    // Ensure thumbnail visible (in case it was black)
    ensureThumbnail(btn, vid);

    // Stop other players
    stopOtherPlayers(wrapper);

    // Hide button then create iframe
    try {
      btn.setAttribute('aria-pressed', 'true');
      btn.style.display = 'none';
      var controlsId = btn.getAttribute('aria-controls') || null;
      var iframeWrap = createIframe(wrapper, vid, controlsId);
      if (iframeWrap) {
        log('[faq-yt] iframe inserted for vid', vid);
      } else {
        log('[faq-yt] iframe creation failed for vid', vid);
        // restore button
        btn.style.display = '';
        btn.setAttribute('aria-pressed', 'false');
      }
    } catch (err) {
      log('[faq-yt] Error creating iframe:', err);
      btn.style.display = '';
      btn.setAttribute('aria-pressed', 'false');
    }
  }, true /* useCapture to catch events earlier and avoid other handlers interfering */);

  // On DOM ready: set data-yt-id and thumbnail where possible
  document.addEventListener('DOMContentLoaded', function () {
    log('[faq-yt] DOMContentLoaded — initializing players');
    document.querySelectorAll('.yt-player').forEach(function (btn) {
      try {
        var vid = btn.getAttribute('data-yt-id') || null;
        var url = btn.getAttribute('data-yt-url') || null;
        if (!vid && url) vid = extractYouTubeID(url);
        if (vid) {
          btn.setAttribute('data-yt-id', vid);
          ensureThumbnail(btn, vid);
          log('[faq-yt] set thumbnail for vid', vid);
        } else {
          // still ensure button is clickable
          btn.style.pointerEvents = 'auto';
        }
      } catch(e) {
        log('[faq-yt] init error for button', btn, e);
      }
    });
  });

  // Extra safety: also attempt to init after a short delay in case DOMContentLoaded already fired earlier
  setTimeout(function () {
    document.querySelectorAll('.yt-player').forEach(function (btn) {
      if (!btn.getAttribute('data-yt-id')) {
        var url = btn.getAttribute('data-yt-url') || null;
        var vid = url ? extractYouTubeID(url) : null;
        if (vid) {
          btn.setAttribute('data-yt-id', vid);
          ensureThumbnail(btn, vid);
          log('[faq-yt] delayed init set thumbnail for vid', vid);
        }
      }
    });
  }, 1000);

})();
